import moment from 'moment';

import { IDLE_TIMEOUT_IN_SECONDS } from 'utils/constants';
import {
  loadLastActivity,
  clearLastActivity,
  clearAuthToken,
  clearTokenStorage,
} from 'utils/tokenStorage';
import Program from 'utils/program';
import { resetAllAfterLogout } from 'actions/authenticate';
import store from 'store';
import { routes } from './routeHelper';

export const isSessionExpired = (): boolean => {
  const lastActivityTime = loadLastActivity();
  const diff = lastActivityTime
    ? moment().diff(parseInt(lastActivityTime, 10))
    : 0;
  return diff > IDLE_TIMEOUT_IN_SECONDS * 1000;
};
export const handleExpiredSession = (isExpired: boolean): void => {
  clearLastActivity();
  if (isExpired) {
    clearAuthToken();
  }
};

export const handleExpiredToken = () => {
  if (window.location.pathname !== routes.LOG_IN) {
    clearTokenStorage();
    /*
     * why do we have the following below?
     * Shouldnt we move away from this since its hardcoding the programs and we can potentially
     * Support new Products or existing Products with a new type?
     */
    Program.clear();
    store.dispatch(resetAllAfterLogout());
    window.location.replace(routes.LOG_IN);
  }
};
